import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function AttributeValidator(errorFnc: () => string) {
    const msg = errorFnc();
    console.log('AttributeValidator', msg);
    let ret = null;
    return (control: AbstractControl): ValidationErrors | null => {
        if (msg && control && (control.value !== null || control.value !== undefined)) {
            ret = {
                error: msg
            };
        }
        console.log('AttributeValidator - ret', msg, ret);
        return ret;
    }
}

export function DynamicAttributeValidator(group: FormGroup): ValidationErrors | null {
    const errorControl = group.get('error');
    const idControl = group.get('errorControl');
    if (errorControl && errorControl.value) {
        return {
            'attribute-error': {
                message: errorControl.value
            } 
        }
    }
    else {
        return null;        
    }
}
export function DynamicAttributeValidator1(attributeId: string): ValidatorFn {
    console.log('DynamicAttributeValidator1 outer', this);      
    return (control: AbstractControl): ValidationErrors|null => {      
    console.log('DynamicAttributeValidator1 inner', control.value);      
     if (!this || !this.currentData || this.currentData.errors) {
        // don't validate values without error data
        return null;
      }
      const msg = this.currentData.errors[attributeId];        
      console.log('DynamicAttributeValidator1', attributeId, msg);      

      return msg ?
          {attributeId: {'message': msg}} :
          null;
    };
  }
export function getAttributeError(type: string, id: string): string {
    return `dws.errors.types.${type}.${id}`;
}